import React, { useEffect, useState } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../../loader/CircleLoade";
import { Link } from "react-router-dom";
import Navbar from "../../../common/Navbar";

export default function RedemptionHistory() {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [redemptionHistory, setRedemptionHistory] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [filterData, setFilterData] = useState({});
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [userTypeData, setUserTypeData] = useState("");

  useEffect(() => {
    getRedemptionHistory(1);
  }, []);

  // Handle select change
  const handleUserTypeChange = (e) => {
    const value = e.target.value;
    setUserTypeData(value);
    setCurrentPage(1);
    // Trigger API call with new filter
    getRedemptionHistoryWithFilter(value, 1);
  };

  const searchFormik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.startDate === "" && data.endDate !== "") {
        errors.startDate = "Please select date";
      }
      if (data.startDate !== "" && data.endDate === "") {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getRedemptionHistory(data, 1);
      setFilterData(data);
    },
  });
  
  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);
  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

  const getRedemptionHistory = async (pageNum) => {
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
      // Build URL based on whether userTypeData has a value
      let url = Constants.baseUrl + 
        `redeem/catelog/orders?sortBy=createdDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`;
      
      // Only add orderType parameter if it has a value
      if (userTypeData) {
        url += `&orderType=${userTypeData}`;
      }

      await axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setRedemptionHistory(dt?.output?.results);
            setTotalPages(dt?.output?.totalPages);
            setLoading(false);
          }
          if (dt.result === "error" || dt.result === "dialog") {
            setRedemptionHistory(null);
            setTotalPages(0);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  // New function to handle API call with userType filter
  const getRedemptionHistoryWithFilter = async (userTypeFilter, pageNum) => {
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
      // Build URL based on whether userTypeFilter has a value
      let url = Constants.baseUrl + 
        `redeem/catelog/orders?sortBy=createdDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`;
      
      // Only add orderType parameter if it has a value
      if (userTypeFilter) {
        url += `&orderType=${userTypeFilter}`;
      }

      await axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setRedemptionHistory(dt?.output?.results);
            setTotalPages(dt?.output?.totalPages);
            setLoading(false);
          }
          if (dt.result === "error" || dt.result === "dialog") {
            setRedemptionHistory(null);
            setTotalPages(0);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const areAllValuesBlank = () => {
    const { startDate, endDate } = searchFormik.values;
    return !startDate && !endDate;
  };

  const downloadReport = () => {
    setDownloadLoading(true);
    try {
      axios
        .post(
          `${Constants.baseUrl}web/evg/csv/download/retailer/voucher`, {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program2,
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setDownloadLoading(false);
            const fileData = new Blob([res.data], { type: "text/csv" });
            const sixDigitRandomNo = Math.floor(
              100000 + Math.random() * 900000
            );
            saveAs(fileData, `Retailer_redemption_history_${sixDigitRandomNo}.csv`);
          } else {
            setDownloadLoading(false);
            swal({
              text: res.data.msg,
              timer: 2000,
              buttons: false,
            });
          }
        });
    } catch (error) {
      console.log(error);
      setDownloadLoading(false);
    }
  };

  return (
    <>
      {loading ? <Oval /> : null}
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h3 className="head2">Retailer Redemption History</h3>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <form>
                <div className="row">
                  <div className="col-md-10">
                    <select 
                      className="form-control report-select-input" 
                      style={{width:"100px"}}
                      value={userTypeData}
                      onChange={handleUserTypeChange}
                    >
                      <option value="">All</option>
                      <option value="UPI">UPI</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                      {/* {redemptionHistory === null ? (
                        ""
                      ) : (
                        <Link
                          to="#"
                          class={`btn btn-primary report-submit-button mx-5 ${
                            downloadLoading ? "btn-opacity" : ""
                          }`}
                          onClick={() => downloadReport()}
                        >
                          {downloadLoading ? (
                            <span>Exporting ...</span>
                          ) : (
                            " Export"
                          )}
                        </Link>
                      )} */}
                  </div>
                </div>
              </form>
              
              <div className="row mt-10">
                <div className="col-md-12">
                  <div className="table-responsive table--no-card">
                    <table
                      className="table table-borderless table-striped table-earning"
                      id=""
                    >
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>RetailerName</th>
                          <th>MobileNo</th>
                          <th>ProductName</th>
                          <th>ProductCode</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>OrderStatus</th>
                          <th>UpiProcessed</th>
                          <th>UpiAmount</th>
                          <th>UpiStatus</th>
                          <th>UpiTransId</th>
                          <th>UpiOrderId</th>
                          <th>UpiRemarks</th>
                        </tr>
                      </thead>
                      {redemptionHistory === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="8"
                              style={{ textAlign: "center", fontSize: "16px" }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {redemptionHistory &&
                            redemptionHistory.length > 0 &&
                            redemptionHistory.map((row, index) => {
                              const serialNumber =
                                (currentPage - 1) * limit + index + 1;

                              const Date = row.createDateTime
                                ? moment(
                                    row.createDateTime,
                                    "DD-MM-YYYY HH:mm"
                                  ).format("DD-MM-YYYY")
                                : "";

                              return (
                                <>
                                  <tr key={index}>
                                    <td>{serialNumber}</td>
                                    <td>{row?.name}</td>
                                    <td>{row?.mobile}</td>
                                    <td>{row?.evgProductName}</td>
                                    <td>{row?.evgProductCode}</td>
                                    <td>{row?.points}</td>
                                    <td>{Date}</td>
                                    <td>{row?.status}</td>
                                    <td>{row?.upiProcessed}</td>
                                    <td>{row?.upiAmount}</td>
                                    <td>{row?.upiStatus}</td>
                                    <td>{row?.upiTransId}</td>
                                    <td>{row?.upiOrderId}</td>
                                    <td>{row?.upiRemarks}</td>
                                  </tr>
                                </>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getRedemptionHistoryWithFilter(userTypeData, page);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}